import { useEffect } from "react";
import Button from "../../../Components/Button/Button";
import classes from "./HomePage.module.scss";
import { useNavigate } from "react-router-dom";
import ArrowWithTail from "../../../assets/icons/ArrowWithTail";

const HomePage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Set the tab name
    document.title = "Net-Zero Transitions: End-to-End Lifecycle Management";

    // Set the meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Begin your Net-Zero journey with Sustainability Economics. We simplify, automate, and scale Net-Zero transitions using cutting-edge technology across sectors."
      );
    } else {
      // If the meta tag doesn't exist, create it
      const meta = document.createElement("meta");
      meta.name = "description";
      meta.content =
        "Begin your Net-Zero journey with Sustainability Economics. We simplify, automate, and scale Net-Zero transitions using cutting-edge technology across sectors.";
      document.head.appendChild(meta);
    }

    return () => {
      document.title = "Default Title";
    };
  }, []);

  return (
    <div className={classes["homepage-container"]}>
      <div className={classes["video-container"]}>
        <div className={classes["video-overlay-container"]}>
          <video
            src={
              "https://se-website-image.s3.ap-south-1.amazonaws.com/homepage-video.mp4"
            }
            autoPlay
            loop
            muted
            controls={false}
            width="100%"
            height="100%"
          ></video>

          <div className={classes.overlay}></div>
        </div>

        <div className={classes["video-text-container"]}>
          <p>
            <span>Where</span>
            <br />
            <span className={classes.bold}>Sustainability</span>
            <br />
            <span>
              meets <span className={classes.bold}>AI</span>
            </span>
          </p>
        </div>

        <Button
          className={classes["get-in-touch-btn"]}
          text={
            <>
              Get in touch <ArrowWithTail width={14} height={10} color="#000" />
            </>
          }
          btnClickHandler={() => navigate("/contact-us")}
        />
      </div>
    </div>
  );
};

export default HomePage;
